import { Accordion } from "flowbite-react"
  const IosFAQ: React.FC = () => { return (
        <>
          <Accordion>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">How much does it cost to develop an iOS App?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  iOS is the right platform to reach your target audience and engage with them. The approximate cost to build an iOS mobile application is between $15,000 to $50,000. There are several factors that affect the cost of iOS app development such as the experience of the iOS developer, feature integration, project portfolio, type of app, etc.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> Do I own the ownership and the code of my iOS application?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Yes, as a part of our contract negotiation, we discuss with our clients the handover of source code ownership upfront. After successful publishing on the App Store, we hand over ownership of the iOS app and its source code.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What types of applications can your iOS developers develop with the iOS framework?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Our iOS developers have extensive experience developing native iOS applications for a wide range of industries. Some of the popular types of iOS app categories include healthcare & fitness apps, food delivery apps, restaurant reservation apps, weather forecasting apps, education & news apps, social networking apps, OTT apps, hotel & cab booking apps, real-time chat apps, and more.
                  </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">Which tools and technologies are used for iOS app development?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  There are many iOS development solutions that tend to show up frequently on our iOS developers favorites lists. Here is a list of the tools and techniques that we use: <br/>
                  <ul className="list mb-0 mt-3">
                      <li>XCode as IDE</li>
                      <li>Swift</li>
                      <li>SwiftUI</li>
                      <li>Invision</li>
                      <li>Figma</li>
                      <li>Objective -C</li>
                      <li>CodeRunner</li>
                      <li>XC Test</li>
                      <li>Gitlab</li>
                      <li>CocoaPods</li>
                    </ul>
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">Which iOS programming languages do you use?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  We use Swift, SwiftUI and Objective-C programming languages, which are widely used for iOS app development for iOS, iPadOS, macOS, and watchOS. Moreover, Swift is also considered as a top programming language for developing iOS apps for a wide range of applications. Since it offers tools for building robust and verified interfaces between code modules as well as access control.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">Will you assist me in uploading my iOS app to the Apple App Store?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Yes. In fact, we take full responsibility for submitting your iOS app to the Apple App Store. It is a component of our full-service iOS app development solution. So please feel free to hire one of our dedicated iOS developers for your upcoming project.
                  </div>
                </Accordion.Content>
              </Accordion.Panel>
            </Accordion>
        </>
        )
}

export default IosFAQ
